module.exports = __webpack_public_path__ + "img/estimate-empty-data.de07768b.svg";